import { render, staticRenderFns } from "./xuncharecord.vue?vue&type=template&id=15db9940&scoped=true&"
import script from "./xuncharecord.vue?vue&type=script&lang=js&"
export * from "./xuncharecord.vue?vue&type=script&lang=js&"
import style0 from "./xuncharecord.vue?vue&type=style&index=0&id=15db9940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db9940",
  null
  
)

export default component.exports